import { render, staticRenderFns } from "./ListThirdPartyServicePage.vue?vue&type=template&id=27c20b01&"
import script from "./ListThirdPartyServicePage.vue?vue&type=script&lang=js&"
export * from "./ListThirdPartyServicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports